export default {
  messages: [
    { id: 1, message: 'Bla bla bla' },
    { id: 2, message: 'Bla bla bla' },
    { id: 3, message: 'Bla bla bla' }
  ]
}
